import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, concatMap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  fetchAdminsRequest,
  fetchAdminsSuccess,
  fetchAdminsFailure,
  createAdminsRequest,
  createAdminsSuccess,
  createAdminsFailure,
  deleteAdminsRequest,
  deleteAdminsSuccess,
  deleteAdminsFailure,
} from './admin.actions';
import { AdminService } from './admin.service';
import { Router } from '@angular/router';

@Injectable()
export class AdminEffects {
  constructor(
    private adminsService: AdminService,
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  public fetchAdminsRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchAdminsRequest),
      concatMap(() => {
        return this.adminsService.getAllAdmins().pipe(
          map((response) => fetchAdminsSuccess({ admins: response })),
          catchError((error) => {
            console.log(error);
            return of(fetchAdminsFailure());
          })
        );
      })
    );
  });

  public createAdminsRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(createAdminsRequest),
      concatMap((action) => {
        return this.adminsService.createAdmin(action.payload).pipe(
          map((response) => {
            this.router.navigate(['/main/admins']);
            return createAdminsSuccess({ admin: response });
          }),
          catchError((error) => {
            if (error.status === 400) {
              this.snackBar.open('Validation error', null, {
                duration: 10000,
              });
            } else {
              this.snackBar.open(error.error.message, null, {
                duration: 10000,
              });
            }
            return of(createAdminsFailure());
          })
        );
      })
    );
  });

  public deleteAdminsRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(deleteAdminsRequest),
      concatMap((action) => {
        return this.adminsService.deleteAdmins(action.payload).pipe(
          map(() => deleteAdminsSuccess({ ids: action.payload.ids })),
          catchError((error) => {
            console.log(error);
            return of(deleteAdminsFailure());
          })
        );
      })
    );
  });
}
